module.exports = __webpack_public_path__ + "img/logo.1abdebc6.svg";